export default "__VITE_ASSET__i30$kMFO__"